import Route from 'cio/routes/base';

export default class SetupRoute extends Route {
  afterModel(model) {
    return model.findRecipients();
  }

  setupController(controller, model) {
    super.setupController(...arguments);

    controller.findNewslettersUsedInPositiveConditionsTask.perform(model.conditions);
  }

  resetController(controller) {
    super.resetController(...arguments);

    controller.findNewslettersUsedInPositiveConditionsTask.cancelAll({ resetState: true });
  }

  redirect(model) {
    if (model.get('isSent')) {
      this.router.transitionTo('broadcasts.newsletter.overview', model);
    }
  }
}
